import { useQuery } from "react-query";
import API from "../shared-utils/api";
import { useCustomer } from "../contexts/CustomerProvider";
export const getWallet = async (userId, pubId) => {
    if (!userId)
        return null;
    const query = pubId ? `?pub_id=${encodeURIComponent(pubId)}` : "";
    const { data } = await API.get(`/api/v1/rbzo/wallet/${userId}/fetchDetails${query}`);
    return data;
};
export const useWallet = (pubId) => {
    var _a;
    const { customerData } = useCustomer();
    const userId = (_a = customerData === null || customerData === void 0 ? void 0 : customerData.id) !== null && _a !== void 0 ? _a : null;
    return useQuery(["wallet", userId, pubId], () => getWallet(userId, pubId), {
        enabled: !!userId,
    });
};
